import { css } from "@emotion/react";

import { colors } from "../../styles";

export const creaTerms = css`
  background-color: ${colors.white};
  padding: 20px;
`;

export const terms = css`
  margin-top: 10px;
`;

export const termsSection = css`
  margin: 30px 0;
`;

export const btn = css`
  margin-right: 20px;
`;
